// extracted by css-extract-rspack-plugin
export default {"box":"m0QDCA2RWFEewHyX"};